export default __webpack_public_path__ + "static/media/rpl11.07157078.jpg";